import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';
import { Icon } from 'components/shared/Icon';

import styles from './MenuTab.module.scss';

const MenuTab = ({
  className,
  active,
  disabled,
  label,
  icon,
  onClick,
}: {
  className: any;
  active: any;
  disabled: any;
  label: any;
  icon: any;
  onClick: any;
}) => (
  <div
    className={cn(
      styles.tab,
      { [styles.tabActive]: active, [styles.tabDisabled]: disabled },
      className,
    )}
    onClick={() => {
      if (disabled) {
        return;
      }
      onClick(label);
    }}
  >
    <Icon className={styles.icon} name={icon} />
    <Typography
      className={styles.text}
      variant="body3"
      weight="medium"
      mode="compact"
    >
      {label}
    </Typography>
  </div>
);

export default React.memo(MenuTab) as any;
